import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { AlertComponent } from '@components/atoms/alert/alert.component';
import { CardMode } from '@components/card/card.component';
import {
    TrainPreferencesComponent,
    TrainPreferencesFormGroup,
} from '@components/molecules/forms/patient-travel-card/train-preferences/train-preferences.component';
import { MdsDividerComponent, MdsExpansionPanelComponent } from '@medpacesoftwaredevelopment/designsystem';
import { TravelRequest } from '@models/request';
import { Study, SupportTier } from '@models/study';
import { RequestStateService } from '@services/state-management/request-state.service';
import { TravelViewModelService } from '@services/travel-view-model/travel-view-model.service';
import { getAlertContent } from '@utility/utility.travel-request';
import { map } from 'rxjs';
import { TrainRequestDetailsFormGroup } from '../../form-groups/detail-form-groups/travel/train-request.formgroup';
import { NeedsTravelFormGroup, TravelFormGroup } from '../../form-groups/travel-request-card.formgroup';
import { NeedsTravelRadioGroupComponent } from '../../needs-travel-radio-group/needs-travel-radio-group.component';
import { TrainRequestDetailsComponent } from './train-request-details/train-request-details.component';

@Component({
    selector: 'medpace-train-travel-request-tab',
    imports: [
        CommonModule,
        MdsDividerComponent,
        MdsExpansionPanelComponent,
        NeedsTravelRadioGroupComponent,
        TrainPreferencesComponent,
        TrainRequestDetailsComponent,
        AlertComponent,
    ],
    templateUrl: './train-travel-request-tab.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './train-travel-request-tab.component.scss',
})
export class TrainTravelRequestTabComponent {
    private readonly requestStateService = inject(RequestStateService);
    private readonly travelViewModelService = inject(TravelViewModelService);

    public readonly mode: InputSignal<CardMode> = input.required();
    public readonly study: InputSignal<Study> = input.required();
    public readonly formGroup: InputSignal<
        NeedsTravelFormGroup<TravelFormGroup<TrainPreferencesFormGroup, TrainRequestDetailsFormGroup>>
    > = input.required();

    public readonly isTrainAvailable: Signal<boolean> = computed(
        () => !!this.study().studyInfo?.studyTravelOptions.find((o) => o.name === 'Trains')
    );
    public readonly isLimitedService = computed(() => this.study()?.supportTier === SupportTier.limitedService);
    public readonly isUpdate = computed(() => !!this.travelViewModelService.travelCardViewModel()?.isUpdate);

    public readonly isTrainRequested$ = this.requestStateService.travelRequestStateService
        .getState()
        .pipe(map((travelRequest: TravelRequest) => travelRequest?.trainRequired));

    public readonly nonAvailableMessage: string = getAlertContent('train');
}
